module.exports = __webpack_public_path__ + "static/img/Jeff-Browne.b66b9ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jeff-Browne.jpg
// module id = 6Je8
// module chunks = 1